import { delay } from '../utils/common-util';

export default {
  /**
   *
   * @param isShowPop boolean 表示是否显示登录弹出窗
   * @param userInfo string 用户登录后的用户名
   * @param isLogin boolean 用户是否登录
   * @param ready 接口是否加载完成
   */
  namespace: 'example',
  state: {
    time: ''
  },

  effects: {
    *updateTime({ payload }, { call, put }) {
      yield call(async () => {
        await delay(200);
      });
      yield put({ type: 'save', payload: { time: new Date().toString() } });
    }
  },
  reducers: {
    save(state, { payload }) {
      return { ...state, ...payload };
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/example.js